import { useSearchParams } from 'react-router-dom';

type Params = {
  [key: string]: string;
};

export const useCustomParams = () => {
  let [searchParams, setSearchParams] = useSearchParams();

  const setParams = (params: Params) => {
    setSearchParams({ ...searchParams, ...params });
  };

  return { searchParams, setParams };
};
